var exports = {
  "kJ": "GiftEmbed.module__iconCircle___N2Vfb2",
  "SP": "GiftEmbed.module__iconCircleActive___N2Vfb2",
  "PP": "GiftEmbed.module__iconCircleInactive___N2Vfb2",
  "_O": "GiftEmbed.module__iconCircleDisabled___N2Vfb2",
  "Kk": "GiftEmbed.module__icon___N2Vfb2",
  "m5": "GiftEmbed.module__iconError___N2Vfb2",
  "DD": "GiftEmbed.module__title___N2Vfb2",
  "jn": "GiftEmbed.module__titlePrimary___N2Vfb2",
  "xP": "GiftEmbed.module__titleTertiary___N2Vfb2",
  "S3": "GiftEmbed.module__titleDanger___N2Vfb2",
  "xF": "GiftEmbed.module__subRow___N2Vfb2",
  "Cz": "GiftEmbed.module__helpRow___N2Vfb2",
  "mj": "GiftEmbed.module__skeletonCircle___N2Vfb2",
  "Iz": "GiftEmbed.module__skeletonTitle___N2Vfb2",
  "hI": "GiftEmbed.module__skeletonHelp___N2Vfb2",
  "G3": "GiftEmbed.module__skeletonButton___N2Vfb2",
};

module.exports = exports;
